/* eslint-disable react/jsx-props-no-spreading */
import React, {FC} from 'react';

import {LinkTrap} from '../../../../../libs/shared/ui/src/components/links/linkTrap';
import {LinkTooltips} from '../../../../../libs/shared/ui/src/components/tooltips/linkTooltips';
import {TextRenderer} from '../../../../../srcCommon/formatters/text/textRenderer';
import {markdownDomComponents} from './markdownDomComponents';

/*
 * Props.
 */

interface LinkifyRendererProps {
  text: string;
}

/*
 * Component.
 */

export const DomLinkifyRenderer: FC<LinkifyRendererProps> = (props) => {
  const {text} = props;

  return (
    <LinkTooltips>
      <LinkTrap>
        <TextRenderer debugIdentifier="linkify-renderer" components={markdownDomComponents} text={text} />
      </LinkTrap>
    </LinkTooltips>
  );
};
